// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__-K3DC","content":"LayoutSettings_content__NcheI"};